import { cn } from '@/lib/cn';

/**
 * Логото на КМД ЕКСПРЕС — истинското, изрязано от оригинала
 * (scripts/brand/build-logos.py). Два варианта според темата: сребро и лайм
 * върху тъмно, графит и наситено зелено върху светло.
 *
 * `tagline` — цялото лого със слогана „KEEP THE MISSION. WE DELIVER eXPRESS.";
 * без него — знакът без слогана. В лентите и менюто слоганът би бил висок
 * пет пиксела и нечетим, затова там е знакът, а слоганът — при входа.
 */
const SIZE = {
  sm: 'h-9 w-auto max-w-none',
  md: 'h-14 w-auto max-w-none',
  lg: 'h-auto w-full max-w-[340px]',
} as const;

export function BrandLogo({
  size = 'md',
  tagline = false,
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  tagline?: boolean;
  className?: string;
}) {
  const kind = tagline ? 'logo' : 'mark';
  const img = cn('select-none', SIZE[size]);
  return (
    <span className={cn('inline-flex', size === 'lg' && 'w-full justify-center', className)}>
      <img
        src={`/brand/kmdx-${kind}-dark.webp`}
        alt="KMDX EXPRESS — КМД ЕКСПРЕС"
        className={cn('kmdx-logo-on-dark', img)}
        draggable={false}
        decoding="async"
      />
      <img
        src={`/brand/kmdx-${kind}-light.webp`}
        alt=""
        aria-hidden="true"
        className={cn('kmdx-logo-on-light', img)}
        draggable={false}
        decoding="async"
      />
    </span>
  );
}
